<script>
	import ScHome from '$lib/home/scwallet/homeportfolio/SCHome.svelte';

	import { walletConnected, walletLoaded } from '$lib/wallet/store';
	import { fly } from 'svelte/transition';
	import PortfolioChartWrapper from './PortfolioChartWrapper.svelte';
	import { quadIn } from 'svelte/easing';
	import UserPositionWithWrapper from './UserPositionWithWrapper.svelte';
	import UserPositions from '$lib/home/userHoldings/UserPositions.svelte';
	import Markets from './Markets.svelte';
	import MarketTopSection from './MarketTopSection.svelte';
</script>

<section class="w-full max-w-screen-2xl mx-auto hidden sm:block">
	<div class="text-fx-white">
		{#if $walletLoaded && $walletConnected}
			<div class="grid grid-cols-2 gap-4">
				<PortfolioChartWrapper />

				<ScHome />
			</div>
		{:else}
			<PortfolioChartWrapper />
		{/if}
		<div class="my-2">
			<MarketTopSection />
		</div>
		<div
			class="mt-4 hidden sm:block"
			in:fly|global={{
				duration: 200,
				x: 0,
				y: 30,
				opacity: 0.1,
				easing: quadIn
			}}
		>
			<UserPositionWithWrapper />
		</div>

		<div class="sm:hidden">
			<div class="mx-2 mt-4 text-fx-gradient-5 font-semibold text-xl">Positions</div>
			<div class="border-t border-fx-grey-800 my-2" />
			<UserPositions />
		</div>
	</div>
	<div class="sm:hidden">
		<div class="mx-2 mt-4 text-fx-gradient-5 font-semibold text-xl">Positions</div>
		<div class="border-t border-fx-grey-800 my-2" />
		<UserPositions />
	</div>
</section>
